// Copyright (c) 2016 Deere & Company

import busyCounter from '../../../shared/reducers/busy-counter';
import {combineReducers} from 'redux';
import criteria from './criteria';
import formatting from './formatting';
import isCriteriaValid from '../../shared/reducers/is-criteria-valid';
import report from './report';
import reportIsScrollable from '../../shared/reducers/report-is-scrollable';
import showNoResultsFound from '../../shared/reducers/show-no-results-found';
import views from './views';

export const getCombinedReducers = () =>
    combineReducers({
        busyCounter,
        criteria,
        formatting,
        isCriteriaValid,
        report,
        reportIsScrollable,
        showNoResultsFound,
        views
    });



// WEBPACK FOOTER //
// ./src/reports/pin-cross-reference/reducers/index.js